import { supabase } from '../../lib/supabase';

export async function getIcsUrl(organization_id: string): Promise<string> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  if (!token) throw new Error('Not authenticated');
  const base = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  const res = await fetch(new URL('/api/crm/ics/url', base).toString(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
    body: JSON.stringify({ organization_id })
  });
  if (!res.ok) {
    const t = await res.text();
    throw new Error(t || 'Failed to generate ICS URL');
  }
  const json = await res.json();
  return json?.url as string;
}
